import $ from 'jquery';
import Util from 'root/module/util';
import Constants from 'root/constants';
import Cache from 'root/cache';
import View from 'view/base';
import { operators } from 'view/user_identification/segment_edit';

export default View.extend({
    tagName: 'form',
    className: 'dropdown-region user-property-filter',

    segment_type: Constants.USER_SEGMENT_TYPE_AND,
    segment_condition: [],

    events: {
        'click .condition-add'      : 'onConditionAdd',
        'click .condition-delete'   : 'onConditionDelete',
        'click .condition-clear'    : 'onConditionClear',
        'click .condition-type li'  : 'onConditionTypeChange',
        'input .search-val input'   : 'onCheckForm',
        'submit'                    : 'onConditionApply'
    },

    dom_handlers: {
        onConditionTypeChange: function(e) {
            this.segment_type = $(e.currentTarget).data('val');
        },

        onConditionAdd: function(e) {
            var default_property = Cache.user_properties.length ? Cache.user_properties[0] : 'identification';
            var condition_template = this.renderConditionTemplate(default_property, 'is', '');

            $(condition_template).appendTo(this.$el.find('.region-conditions'));

            this.checkForm();
        },

        onConditionDelete: function(e) {
            $(e.currentTarget).parents('.condition-item:first').remove();
            this.checkForm();
        },

        onConditionApply: function() {
            var conditions = this.getConditions();
            this.trigger('submit', conditions);
        },

        onConditionClear: function() {
            this.trigger('submit', {
                segment_type: this.segment_type,
                segment_condition: []
            });
        },

        onCheckForm: function() {
            this.checkForm();
        }
    },

    initialize: function(options) {
        this.segment_type      = options.segment_type || Constants.USER_SEGMENT_TYPE_AND;
        this.segment_condition = options.segment_condition || [];
    },

    getUserPropertyName: function(property_key) {
        // system keys
        if (property_key === 'identification') {
            return 'User ID';
        } else if (property_key === 'email') {
            return 'Email';
        } else if (property_key === 'display_name') {
            return 'Name';
        }

        // custom keys
        return property_key;
    },

    getConditions: function() {
        var conditions = [];

        this.$el.find('.condition-item').each((index, el) => {
            var condition_key      = $(el).find('.search-key li.selected').data('val');
            var condition_operator = $(el).find('.search-operator li.selected').data('val');
            var condition_value    = $(el).find('.search-val input').val().trim();

            if (condition_value) {
                conditions.push({
                    key: condition_key,
                    operator: condition_operator,
                    value: condition_value
                });
            };
        });

        return {
            segment_type: this.segment_type,
            segment_condition: conditions
        };
    },

    checkForm: function() {
        this.$el.find('.condition-delete').prop('disabled', this.$el.find('.condition-item').length <= 1);
    },

    renderConditionTemplate: function(user_property, operator, user_value) {
        var user_properties = '';
        Cache.user_properties.forEach((user_key) => {
            user_properties += '<li data-val="' + Util.htmlEntities(user_key) + '"' + (user_property === user_key ? ' class="selected"' : '') +'>' + Util.htmlEntities(this.getUserPropertyName(user_key)) + '</li>';
        });

        var operator_options = '';
        Object.keys(operators).forEach((key) => {
            operator_options += '<li data-val="' + key + '"' + (operator === key ? ' class="selected"' : '') + '>' + operators[key]+ '</li>';
        });

        var template =
        '<div class="condition-item">' +
            '<button type="button" class="condition-delete small square round text-icon"><i class="fa-solid fa-circle-minus"></i></button>' +

            '<div>' +
                '<div class="search-key button-dropdown button-dropdown-left button-dropdown-large" data-update="true" data-append="true">' +
                    '<button type="button" class="dropdown-select">' + Util.htmlEntities(this.getUserPropertyName(user_property)) +'</button>' +
                    '<div>' +
                        '<ul class="dropdown dropdown-select">' +
                            '<li data-val="identification"' + (user_property === 'identification' ? ' class="selected"' : '') + '>User ID</li>' +
                            '<li data-val="email"' + (user_property === 'email' ? ' class="selected"' : '') + '>Email</li>' +
                            '<li data-val="display_name"' + (user_property === 'display_name' ? ' class="selected"' : '') + '>Name</li>' +
                            '<li class="separator"></li>' +
                            '<li class="dropdown-title">Custom Properties</li>' +
                            (user_properties ||
                            '<li class="disabled">No custom properties identified</li>')  +
                        '</ul>' +
                    '</div>' +
                '</div>' +

                '<div class="search-operator button-dropdown button-dropdown-left button-dropdown-large" data-update="true" data-append="true">' +
                    '<button type="button" class="dropdown-select">' + (operators[operator] || 'is') + '</button>' +
                    '<div>' +
                        '<ul class="dropdown dropdown-select">' + operator_options + '</ul>' +
                    '</div>' +
                '</div>' +

                '<div class="search-val"><input type="text" class="solid compact"' + (user_value ? ' value="' + Util.htmlEntities(user_value) + '"' : '') + '></div>' +
            '</div>' +
        '</div>';

        return template;
    },

    render: function() {
        var default_property = Cache.user_properties.length ? Cache.user_properties[0] : 'identification';

        var condition_options = '';
        this.segment_condition.forEach((condition) => {
            condition_options += this.renderConditionTemplate(condition.key, condition.operator, condition.value);
        });

        if (!condition_options) {
            condition_options = this.renderConditionTemplate(default_property, 'is', '');
        }

        var content =
        '<div class="region-conditions">' +
            '<div class="margin-bottom-12">When ' +
                '<div class="condition-type button-dropdown button-dropdown-left" data-update="true" data-append="true">' +
                    '<button type="button" class="dropdown-select">All</button>' +
                    '<div>' +
                        '<ul class="dropdown dropdown-select">' +
                            '<li data-val="' + Constants.USER_SEGMENT_TYPE_AND + '">All</li>' +
                            '<li data-val="' + Constants.USER_SEGMENT_TYPE_OR + '">Any</li>' +
                        '</ul>' +
                    '</div>' +
                '</div>' +
            ' of the conditions match</div>' +
            condition_options +
        '</div>' +
        '<div class="region-actions">' +
            '<button type="button" class="condition-add text-primary-small"><i class="fa-solid fa-circle-plus"></i>Add condition</button>' +
            '<div class="margin-top-24">' +
                '<button type="submit" class="condition-apply primary small min">Apply</button>' +
                '<button type="button" class="condition-clear tertiary small min margin-left-8">Clear</button>' +
            '</div>' +
        '</div>';

        this.$el.html(content);

        this.$el.find('.condition-type > button').text(this.segment_type === Constants.USER_SEGMENT_TYPE_AND ? 'All' : 'Any');
        this.$el.find('.condition-type li[data-val="' + this.segment_type + '"]').addClass('selected');

        this.checkForm();

        return this;
    }
});